export async function resolveApiErrorMessage(
  res: Response,
  fallbackMessage: string,
): Promise<string> {
  let backendMessage = '';
  try {
    const body = (await res.json().catch(() => ({}))) as {
      message?: string | string[];
      error?: string;
    };
    if (Array.isArray(body.message)) {
      backendMessage = body.message.filter(Boolean).join(', ');
    } else if (typeof body.message === 'string') {
      backendMessage = body.message;
    } else if (typeof body.error === 'string') {
      backendMessage = body.error;
    }
  } catch {
    // ignore parse failures
  }

  if (res.status === 403) {
    return (
      backendMessage
      || 'Permission denied: you are not allowed to perform this action.'
    );
  }

  return backendMessage || fallbackMessage;
}
